import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CodeInput from 'react-code-input';
import { translate } from 'react-polyglot';
import classNames from 'classnames';
import getPossessiveForm from '../../helpers/possessive';
import Section from '../edu/Section';
import { DIARY_PIN_SIZE } from './index';
import FormFeedback from '../form/FormFeedback';
import './DiaryLock.css';
import '../form/WrappedCodeInput.css';

class DiaryLock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitted: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    if (value.length === DIARY_PIN_SIZE) {
      this.props.handleUnlock(value);
      this.setState(() => ({ isSubmitted: true }));
    } else {
      this.setState(() => ({ isSubmitted: false }));
    }
  }

  render() {
    const { firstName, t } = this.props;
    const isRejected =
      this.props.showIncorrectMessage && this.state.isSubmitted;

    return (
      <div>
        <div className="page-header">
          <h1>
            {t('diary.ownersDiary', { owner: getPossessiveForm(firstName) })}
          </h1>
        </div>
        <Section colorScheme="red">
          <div className="container--content">
            <div className="card diary-lock__card">
              <p className="diary-lock__intro">{t('diaryLock.pinEntry')}</p>
              <CodeInput
                className={classNames('form-code-input', {
                  'form-code-input--reject': isRejected
                })}
                onChange={this.handleChange}
                type="password"
                fields={DIARY_PIN_SIZE}
              />
              {isRejected && (
                <div className="diary-lock__incorrect-message">
                  <FormFeedback positive={false}>
                    {t('diaryLock.incorrect')}
                  </FormFeedback>
                </div>
              )}

              <p className="diary-lock__note text-note">
                {t('diaryLock.resetPinDescription')}{' '}
                <button
                  className="diary-lock__email-link button button--link text-link"
                  onClick={this.props.handleOpenForgotPinModal}
                >
                  {t('diaryLock.resetPinLink')}
                </button>
              </p>
            </div>
          </div>
        </Section>
      </div>
    );
  }
}

DiaryLock.propTypes = {
  firstName: PropTypes.string.isRequired,
  handleUnlock: PropTypes.func.isRequired,
  handleOpenForgotPinModal: PropTypes.func.isRequired,
  showIncorrectMessage: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

export default translate()(DiaryLock);



// WEBPACK FOOTER //
// ./src/components/diary/DiaryLock.js